// extracted by mini-css-extract-plugin
export default {"paragraphReveal":"ParagraphRevealStandalone_paragraphReveal__yjXN0","word":"ParagraphRevealStandalone_word__ZTbIy"};